import React from "react";
import { Wrapper } from "../Wrapper/Wrapper";
import { LangContext } from "../../context/lang/LangContext";
import { english } from "../../context/lang/langs/englishMessages";
import { LangAdvice } from "./LangAdvice";

interface Props {
  data: {
    markdownRemark: {
      html: string;
      frontmatter: {
        date: string;
        title: string;
        slug_en: string;
        slug_es: string;
        lang: string;
      };
    };
  };
  lang: typeof english;
}

export function BlogPostTemplate({
  data,
  lang, // this prop will be injected by the GraphQL query below.
}: Props) {
  const { markdownRemark } = data; // data.markdownRemark holds your post data
  const { html } = markdownRemark;
  return (
    <LangContext.Provider value={{ messages: lang }}>
      <Wrapper>
        <div className="ForDevelopers ForDevelopers_Blog">
          <div className="ForDevelopers__BlogPostTemplate">
            <LangAdvice frontmatter={data.markdownRemark.frontmatter} />
            <div className="Blog" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </Wrapper>
    </LangContext.Provider>
  );
}
